/**
 * Форма прямого поступления через р/с МКК
 */

import React from 'react';
import { Formik, Form } from 'formik';
import { TextInput, Select } from '../../../components/UI/FormItems';
import { useCreateDirectReceipt } from '../../../hooks/useAdmin';
import { directReceiptSchema } from '../validation/schemas';
import type { DirectReceiptParams } from '../../../types';

interface DirectReceiptFormValues {
  sum: string;
  date: string;
  account: string;
}

interface DirectReceiptFormComponentProps {
  creditContractId: number | null;
  selectedClientName: string;
}

/**
 * Компонент формы погашения через р/с МКК
 */
export const DirectReceiptFormComponent: React.FC<DirectReceiptFormComponentProps> = ({
  creditContractId,
  selectedClientName,
}) => {
  const createDirectReceiptMutation = useCreateDirectReceipt();

  const initialValues: DirectReceiptFormValues = {
    sum: '',
    date: '',
    account: '40701810700820000033',
  };

  const handleSubmit = async (values: DirectReceiptFormValues, { resetForm, setSubmitting }: { resetForm: () => void; setSubmitting: (v: boolean) => void }) => {
    const sum = Number(values.sum);
    if (!creditContractId || !sum || !values.date) {
      setSubmitting(false);
      return;
    }

    const params: DirectReceiptParams = {
      creditContractId,
      sum,
      date: values.date,
      account: values.account,
    };

    try {
      await createDirectReceiptMutation.mutateAsync(params);
      resetForm();
    } catch (error) {
      // Ошибка уже обработана в onError хука
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <fieldset>
      <Formik
        key={creditContractId || 'no-client'}
        initialValues={initialValues}
        validationSchema={directReceiptSchema}
        onSubmit={handleSubmit}
      >
        {() => (
          <Form>
            <div style={{ display: 'table' }}>
              <div style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                Погашение через р/с МКК
              </div>
              {selectedClientName && (
                <div style={{ marginLeft: '10px', fontSize: '14px', color: '#666' }}>
                  Клиент: {selectedClientName}
                </div>
              )}
              <div style={{ marginTop: '20px' }} />

              <TextInput label="Сумма: " name="sum" placeholder="0.00" />
              <TextInput type="date" name="date" label="Дата: " />

              <Select label="Р/с" name="account">
                <option value="40701810700820000033">40701810700820000033</option>
                <option value="40701810200770000241">40701810200770000241</option>
              </Select>

              <button
                className="btn"
                type="submit"
                disabled={createDirectReceiptMutation.isPending || !creditContractId}
                style={{ marginLeft: '10px' }}
              >
                {createDirectReceiptMutation.isPending
                  ? 'Запись...'
                  : 'Записать погашение на р/с МКК'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </fieldset>
  );
};
